window.rowStyleFormatter = function(row) {
    let backgroundColor = (typeof row.background_color !== "undefined") ? row.background_color : "#ffe6e6";
    let color = (typeof row.color !== "undefined") ? row.color : "#cc0000";
    if (parseInt(row.highlight, 10) === 1) {
        return {
            css: {
                "background-color": backgroundColor,
                "color": color
            }
        };
    } else {
        return {};
    }
};
